module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo2-598e73957e8a1c4107941abbb89a4da7.jpg";